import { useNavigate } from 'react-router-dom';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';

const profileIcon = require('../../../../../assets/icons/edit_profile.svg').default;
const supportIcon = require('../../../../../assets/icons/support.svg').default;
const handIcon = require('../../../../../assets/icons/hand.svg').default;
const handsIcon = require('../../../../../assets/icons/hands.svg').default;

function WelcomeBox() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <span className={styles.title}>Welcome to MeritFinder</span>
            <div className={styles.content}>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><img src={profileIcon} alt="" /></div>
                    <span className={styles.content_item_text}>
                        Complete your profile to have
                        more chance to choose
                    </span>
                </div>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><img src={handIcon} alt="" /></div>
                    <span className={styles.content_item_text}>Be available for exams</span>
                </div>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><img src={supportIcon} alt="" /></div>
                    <span className={styles.content_item_text}>Be ready for Interviews</span>
                </div>
                <div className={styles.content_item}>
                    <div className={styles.content_item_icon}><img src={handsIcon} alt="" /></div>
                    <span className={styles.content_item_text}>Receive offer and hired</span>
                </div>
            </div>
            <div className={styles.button}>
                <Button text='Review your profile' onClick={() => navigate('/workspace/account')} />
            </div>
        </div>
    );
};

export default WelcomeBox;
